<template>
	<el-dialog title="系统提示" :visible.sync="dialogVisible" width="600px" class="overdue-prompt" :before-close="closedFn">
		<div>
			<div class="textC"><img src="~@/assets/img/tanchuang/icon-3.png" alt="" class="imgsize" /></div>
			<div class="text-info textC">
				<p class="c-red">您的系统服务已逾期</p>
				<p>请联系：173-0849-1715</p>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="closedFn" class="deletbtn">
				<img src="~@/assets/img/tanchuang/quxiao.png" alt="" />
				关闭
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	props: {
		tips: {
			type: String,
			default: '删除成功'
		}
	},
	data() {
		return {
			dialogVisible: false
		};
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		closedFn(){
			this.dialogVisible = false;
			this.$emit('loginOut')
		}
	}
};
</script>

<style lang="less">
.overdue-prompt {
	.el-dialog .el-dialog__body {
		padding-top: 33px;
		padding-bottom: 36px;
	}

	.el-dialog .el-dialog__footer {
		padding-top: 0px;
		padding-bottom: 48px;
	}

	.texts {
		font-family: MicrosoftYaHei;
		// font-size: 18px;
		// font-weight: normal;
		// font-stretch: normal;
		// letter-spacing: 1px;
		// color: #47ba6d;
		margin-top: 12px;

		font-family: MicrosoftYaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #666666;
	}

	.addbtn {
		width: 140px;
		height: 40px;
		background-color: #0092f1;
		border-radius: 3px;
		padding: 0px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 12px 42px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			align-content: space-around;
			justify-content: center;
		}
	}

	.deletbtn {
		width: 190px;
		height: 40px;
		background-color: #fff;
		border-radius: 3px;
		font-family: MicrosoftYaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #0092f1;
		padding: 0px;
		// margin-left: 27px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button {
			padding: 12px 66px;
		}
		& > span {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			align-content: space-around;
			justify-content: center;
		}
	}

	// .imgsize {
	// 	width: 72px;
	// 	// height: 72px;
	// }
	.text-info {
		margin-top: 18px;
		p {
			font-family: MicrosoftYaHei;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 1px;
			color: #535353;
			&:first-child {
				font-family: MicrosoftYaHei;
				font-size: 20px;
				font-weight: normal;
				font-stretch: normal;
				line-height: 26px;
				letter-spacing: 2px;
				color: #f42833;
			}
		}
	}
}
</style>
